module.exports = __webpack_public_path__ + "static/media/laundry_package.d4f9e95c.jpg";